// Shared footprint for icon-only sidebar controls. Keep expanded rows independent.
export const collapsedSidebarControlSx = {
  width: 40,
  height: 40,
  borderRadius: 1
} as const;
